"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plcInput_1 = require("../plcInput");
const plc_1 = require("../../../plc/src/plc");
const plcValidator_1 = require("../../../plc/src/domain/plcValidator");
let PlcTextboxComponent = class PlcTextboxComponent extends plcInput_1.PlcInput {
    constructor(inaxPlc) {
        super(inaxPlc);
        this._updateDisabled = false;
        this._currentValueChanged = false;
        /* SPECIFIC INPUTS */
        this.defaultText = '<empty>';
        this.minvalue = '';
        this.maxvalue = '';
    }
    ngOnInit() {
        this.initializeDefaultProperties();
        this.initialize();
        this.subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    get Value() {
        if (this._value.search(/[^\s]/) === -1) {
            // if value is whitespace only, display defaultText
            return this.defaultText;
        }
        return this._value;
    }
    set Value(val) {
    }
    initialize() {
        // initialize textbox-specific properties
    }
    /**
     * disables the updating of the textbox's content when it is being edited
     * this function is called when the textbox gains focus or is edited
     */
    disableUpdate() {
        this._updateDisabled = true;
    }
    /**
     * reenables the updating of the textbox's content
     * - if there has been a DataChangeEvent during the edit and a different value has been read,
     *   the value of the textbox is now updated to the last value that has been read
     */
    enableUpdate() {
        this._updateDisabled = false;
        // write queue to value if it has changed, then clear queue
        if (this._currentValueChanged) {
            this._value = this._currentValue;
            this._currentValue = '';
            this._currentValueChanged = false;
        }
    }
    /**
     * updates the current value unless updating has been disabled
     * - if updating is disabled, the value is instead stored to be called by enableUpdate()
     *   and a falg is set to indicate that the value has changed
     *
     * @param value     the value to set
     */
    updateValue(value) {
        if (this._updateDisabled) {
            this._currentValue = value; // if updating is disabled, write value to storage and mark value as changed
            this._currentValueChanged = true;
        }
        else {
            this._value = value;
        }
    }
    /**
     * Event handler for keystrokes in the textbox
     * - on 'Enter', a writing operation for the textbox's value is initialized and
     *   updating is reenabled
     * - for all other keys, updating is disabled
     *
     * @param val       the value of the textbox that should be written
     * @param event     the javascript KeyboardEvent triggered by the keystroke
     */
    handleInputKeystroke(event, val) {
        if (event.keyCode === 13) {
            this.checkMinMaxWrite(val);
            this.enableUpdate();
        }
        else {
            this.disableUpdate(); // on continuing with edit (typing something)
        }
    }
    /**
     * checks if the value to-be-written is inside of the specified limits (min/max)
     * before calling the 'write' function
     *
     * @param value     the value which should be validated and written
     */
    checkMinMaxWrite(value) {
        if (plcValidator_1.PlcValidator.validMinMax(value, this._valueType, this.minvalue, this.maxvalue)) {
            this.write(value);
        }
        else {
            console.warn('ERROR: value invalid (out of specified range)');
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcTextboxComponent.prototype, "defaultText", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcTextboxComponent.prototype, "minvalue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PlcTextboxComponent.prototype, "maxvalue", void 0);
PlcTextboxComponent = __decorate([
    core_1.Component(Object.assign({
        selector: 'plc-textbox',
        templateUrl: './@inax/plcUi/src/plcTextbox/plc-textbox.component.html',
        styleUrls: ['./@inax/plcUi/src/plcTextbox/plc-textbox.component.css']
    }, plcInput_1.PlcInput.metaData)),
    __metadata("design:paramtypes", [plc_1.InaxPlcService])
], PlcTextboxComponent);
exports.PlcTextboxComponent = PlcTextboxComponent;
